var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoMeta({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.517,
    height: 20,
    viewBox: "0 0 31.517 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_245779",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 245779",
    d: "M10.9,7.558a5.086,5.086,0,0,0-4.694,3.13,60.926,60.926,0,0,0-1.992,7.52,5.021,5.021,0,0,0-.13,1.493,3.624,3.624,0,0,0,1.067,2.592,3.3,3.3,0,0,0,2.2.65,3.3,3.3,0,0,0,2.8-1.551l2.532-4.051,3.485-5.808-.9-1.505A5.086,5.086,0,0,0,10.9,7.558Zm6.61,1.732-.27-.45A7.393,7.393,0,0,0,4.078,9.8a61.944,61.944,0,0,0-2.118,7.923,7.294,7.294,0,0,0-.173,2.183A5.881,5.881,0,0,0,3.66,24.053a5.577,5.577,0,0,0,3.691,1.2,5.608,5.608,0,0,0,4.756-2.636l2.538-4.06,2.868-4.779,2.857,4.761,2.549,4.078a5.608,5.608,0,0,0,4.756,2.636A5.336,5.336,0,0,0,31.658,23.7a6.992,6.992,0,0,0,1.623-4.988,20.431,20.431,0,0,0-1.021-5.03c-.517-1.713-1.075-3.242-1.246-3.7-.039-.1-.084-.22-.137-.341a7.393,7.393,0,0,0-13.095-.8Zm1.346,2.243,3.485,5.808,2.532,4.051a3.3,3.3,0,0,0,2.8,1.551,3.049,3.049,0,0,0,2.314-.835,4.761,4.761,0,0,0,.986-3.4,18.679,18.679,0,0,0-.923-4.363c-.5-1.647-1.036-3.125-1.2-3.566-.03-.081-.056-.147-.083-.207a5.086,5.086,0,0,0-9.007-.549Z",
    transform: "translate(-1.764 -5.25)",
    fill: "#5e94ff",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoMeta);
export default __webpack_public_path__ + "static/media/ico_meta.8857da1a4cbf71ce679624eaf6ba964d.svg";
export { ForwardRef as ReactComponent };